import React from "react";
import Form from "./form";
import { UPDATE_LMBC_HCP } from "./query";
import { Helper } from "../../services";
import { type Props } from "./types";

function Update(props: Props) {
    const { formData } = props;
    const updateData = {
        ...formData,
        monday: Helper.arrToString(formData.monday),
        tuesday: Helper.arrToString(formData.tuesday),
        wednesday: Helper.arrToString(formData.wednesday),
        thursday: Helper.arrToString(formData.thursday),
        friday: Helper.arrToString(formData.friday),
        saturday: Helper.arrToString(formData.saturday),
        sunday: Helper.arrToString(formData.sunday),
        gender: formData.gender.toUpperCase(),
    };

    return (
        <>
            <h5>Update Dermatologist</h5>
            <Form formType="update" formData={updateData} query={UPDATE_LMBC_HCP} />
        </>
    );
}

export default Update;
